import { CURRENCIES } from 'src/features/payStations/types';
import { MEMBERSHIP_ROLES } from 'src/features/userManagement/types';

import type { CardsStatistic, SpacesStatistic } from 'src/features/statistics/types';

export enum WEEKDAY {
    MONDAY = 0,
    TUESDAY = 1,
    WEDNESDAY = 2,
    THURSDAY = 3,
    FRIDAY = 4,
    SATURDAY = 5,
    SUNDAY = 6,
}

export enum POINTS_OF_INTEREST {
    SHOPPING_CENTER = 'shopping_center',
    PARK = 'park',
    MUSEUM = 'museum',
    HISTORICAL_SITE = 'historical_site',
    GALLERY = 'gallery',
    STADIUM = 'stadium',
    HOTEL = 'hotel',
    RESTAURANT = 'restaurant',
    BAR = 'bar',
    HOSPITAL = 'hospital',
}

export type ParkingPointsOfInterest = {
    id: string;
    name: string;
    type: POINTS_OF_INTEREST;
};

type WorkingTimeObject = {
    week_day: WEEKDAY;
    start_time: string | null;
    end_time: string | null;
};

export enum FEATURES {
    RESTROOM = 'restroom',
    UNDERGROUND = 'underground',
    SECURITY = 'security',
    ATM = 'atm',
    RESTAURANTS = 'restaurants',
    PHARMACY = 'pharmacy',
    GROCERIES = 'groceries',
    SHOPPING_CENTER = 'shopping_center',
    SHOPPING_MALL = 'shopping_mall',
    EV_CHARGER = 'ev_charger',
    CAR_WASH = 'car_wash',
    COVERED = 'covered',
    HANDICAP_SPOTS = 'handicap_spots',
}

export enum GEO_TYPES {
    POINT = 'point',
    AREA = 'area',
}

export type City = {
    id: string;
    serial_id: number;
    name: string;
};

export type Coordinates = {
    type: string;
    coordinates: number[];
};

interface Parking {
    id: string;
    system_id: string;
    name: string;
    address: string;
    country: string;
    city: string;
    users_count: number;
    statistic_spaces: SpacesStatistic;
    statistic_cards: CardsStatistic;
    number_of_spaces: number;
    updated_at: string;
    created_at: string;
    description: string;
    pricing_description: string;
    is_24_7: boolean;
    number_of_floors: number;
    is_public: boolean;
    is_featured: boolean;
    photo: string;
    enable_online_payments: boolean;
    enable_online_reservations: boolean;
    latitude: string;
    longitude: string;
    serial_id: number;
    capacity: number;
    limit_to_capacity: boolean;
    working_time: Record<WEEKDAY, { start_time: string | null; end_time: string | null }>;
    working_time_data: WorkingTimeObject[];
    features: FEATURES[];
    geo_type: GEO_TYPES;
    coordinates: Coordinates | null;
    polygon: Coordinates | null;
    area_color: string | null;
    default_currency: CURRENCIES;
    has_own_payment_provider: boolean;
    subdomain: string | null;
    roles: MEMBERSHIP_ROLES[];
}

// The sub parkings are the ones in the Smartpark API and not our own
interface SubParking {
    id: string;
    name: string;
    capacity: number;
    limit_to_capacity: boolean;
}

export type { Parking, SubParking };
